export function listText(values, fallback = "Not set") {
  if (!Array.isArray(values) || values.length === 0) return fallback;
  return values.filter(Boolean).join(", ") || fallback;
}

export function titleInitials(title = "") {
  const words = String(title || "Hook'd")
    .replace(/[^\w\s']/g, " ")
    .split(/\s+/)
    .filter(Boolean);

  return words.slice(0, 2).map((word) => word[0]?.toUpperCase()).join("") || "HC";
}

export function getShowImage(show = {}) {
  return (
    show.poster_url ||
    show.poster ||
    show.image_url ||
    show.image ||
    show.thumbnail ||
    show.backdrop_url ||
    show.artwork_url ||
    null
  );
}

function firstUrl(...values) {
  return values.find((value) => typeof value === "string" && /^https?:\/\//i.test(value));
}

function encodedTitle(show = {}, suffix = "") {
  const title = String(show.title || "").trim();
  return title ? encodeURIComponent(`${title}${suffix}`) : "";
}

export function getWatchUrl(show = {}) {
  const directUrl = firstUrl(
    show.watch_url,
    show.streaming_url,
    show.homepage_url,
    show.homepage,
    show.external_ids?.justwatch
  );

  if (directUrl) return directUrl;

  const query = encodedTitle(show);
  return query ? `https://www.justwatch.com/us/search?q=${query}` : "https://www.justwatch.com/us";
}

export function getTrailerUrl(show = {}) {
  const directUrl = firstUrl(
    show.trailer_url,
    show.trailer,
    show.preview_url,
    show.pitch?.trailer_url
  );

  if (directUrl) return directUrl;

  const query = encodedTitle(show, " trailer");
  return query ? `https://www.youtube.com/results?search_query=${query}` : "https://www.youtube.com";
}

export function normalizeTags(values = []) {
  if (!Array.isArray(values)) return [];
  return values
    .filter(Boolean)
    .map((value) => String(value).replace(/_/g, " "));
}

export function slugifyShowTitle(title = "") {
  return String(title || "untitled")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "") || "untitled";
}

export function showPath(show = {}) {
  const slug = slugifyShowTitle(show.title);
  return `/shows/${show.id ? `${show.id}-` : ""}${slug}`;
}

export function showMatchesKey(show = {}, showKey = "") {
  const key = String(showKey || "");
  const id = show.id == null ? null : String(show.id);

  return (
    (id && (key === id || key.startsWith(`${id}-`))) ||
    key === slugifyShowTitle(show.title)
  );
}

export function searchTextForShow(show = {}) {
  const pitch = show.pitch || {};
  return [
    show.title,
    show.platform,
    show.age_rating,
    show.commitment_level,
    ...(show.genres || []),
    ...(show.moods || []),
    ...(show.cultural_tags || []),
    ...(show.identity_tags || []),
    ...(show.representation_tags || []),
    ...(show.empress_tags || []),
    pitch.hook,
    pitch.empress_hook,
    pitch.why_youll_love_it,
    pitch.binge_strategy,
    pitch.safety_note,
  ]
    .filter(Boolean)
    .join(" ")
    .toLowerCase();
}
